<template>
  <section class="publish clear">
    <div class="selectHead">
      布置作业
      <div class="stepBar fr">
        <img src="../../assets/img/step3.png" alt="">
        <p>
          <span class="active">布置对象</span>
          <span class="active">选择内容</span>
          <span class="active">作业留言</span>
        </p>
      </div>
    </div>
    <div class="layer">
      <div class="work_title">
        <edit-input :defalutTitle="workName" @changeTitle="changeTitle"></edit-input>
      </div>
      <div class="main">
        <div class="publishTarget">
          <article class="secondBox" style="padding: 26px 50px 10px 50px;">
            <div class="grids clear">
              <span class="choose">布置班级</span>
              <div class="student_details">
                <span>{{target}}</span>
              </div>
            </div>
            <!-- <div class="" style="color: #00ba8f; margin: 0px 0 40px 104px; font-size: 14px; cursor: pointer;" @click="adClass">
            调整班级
          </div> -->
          </article>
          <article class="secondBox contents" v-show="params_type != 2" style="padding: 0px 50px 20px 50px;">
            <div class="grids clear">
              <span class="choose">作业内容</span>
              <div class="work_details">
                <p style="font-size: 14px;color:#999;">共选
                  <span style="color: #00ba8f; padding: 0 3px; font-weight: bold;">{{articles.length}}</span>
                  条内容，预计
                  <span style="color: #00ba8f; padding: 0 3px; font-weight: bold;">{{allTimes}}</span>
                  分钟完成作业</p>
                <ul>
                  <li v-for="(item, index) in articles" :key="index">
                    <!-- <img src="../../assets/img/read.png" alt="" v-if="item.moduleId === 10 || item.moduleId === 127">
                  <img src="../../assets/img/online.png" alt="" v-if="item.moduleId === 124">
                  <img src="../../assets/img/video.png" alt="" v-if="item.moduleId === 126">
                  <img src="../../assets/img/listen.png" alt="" v-if="item.moduleId === 15"> -->
                    <span>{{item.resourceName}}</span>
                    <span v-if="item.moduleId == 10 || item.moduleId == 127">
                      <!-- <span v-if="item.versionId == 0">({{words_text[JSON.parse(item.requirementContent).speekingtype-1]}}</span>
                    <span v-else>({{text_text[JSON.parse(item.requirementContent).speekingtype-1]}}</span>
                    <span>/{{JSON.parse(item.requirementContent).readtimes}}次)</span> -->
                    </span>
                    <!-- <span class="preview" @click="preview(item, index)" v-show="item.moduleId !== 126">预览</span> -->
                  </li>
                </ul>

              </div>
              <!-- <div class="" style="color: #00ba8f; margin-top: 20px; margin-left: 104px; font-size: 14px; cursor: pointer;" onclick="javascript:history.back(-1);">
              调整内容
            </div> -->
            </div>
          </article>
        </div>

        <div class="publishTime">
          <article class="secondBox" style="padding: 30px 50px 0px 50px;margin-top:20px;">
            <div class="grids time clear">
              <span class="choose">发布时间</span>
              <div class="selectTime">
                <p class="radio" @click="modify(1)" :class="{'active': !dateShow}">
                  立即发布
                </p>
                <p class="radio" @click="modify(2)" :class="{'active': dateShow}">
                  定时发布
                </p>
                <div class="" v-show="dateShow" style="display: inline-block;">
                  <input id="myIDSecond" v-model="sendDate" class="timing" />
                  <div class="times sel_hours">
                    <origin-select :data="23" selectObj="time_hours" @selecter="selecter" :defValue="default_V.Hour"></origin-select>
                    <p>时</p>
                  </div>
                  <div class="times sel_minutes">
                    <origin-select :data="59" selectObj="time_minutes" @selecter="selecter" :defValue="default_V.defMinute"></origin-select>
                    <p>分</p>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <article class="secondBox">
            <div class="grids time secondBox" style="padding: 20px 50px 0px 54px;">
              <span class="font_14" style="color:#999;">截止时间</span>
              <input id="myID" v-model="endDate" class="timing" style="margin-left: 35px;" />
              <div class="times sel_hours">
                <origin-select :data="23" selectObj="hours" @selecter="selecter" :defValue="default_V.defHour"></origin-select>
                <p>时</p>
              </div>
              <div class="times sel_minutes">
                <origin-select :data="59" selectObj="minutes" @selecter="selecter" :defValue="default_V.defMinute"></origin-select>
                <p>分</p>
              </div>
            </div>
          </article>
          <article class="firstBox">
            <div class="grids clear" style="padding: 20px 0 30px 54px;">
              <span class="font_14">作业留言</span>
              <div class="workMessage">
                <textarea maxlength="100" class="textarea" v-model="workMessage" placeholder="同学们，请按时完成作业哦！" style="resize:none;"></textarea>
                <i class="smallpro">您最多可以输入
                  <i style="color: #00ba8f;">100</i>个字</i>
              </div>
            </div>
          </article>
        </div>
      </div>

      <notice :params="noticParams" :isNotice="isNotice" @isConfirm="isConfirm"></notice>
    </div>
    <article class="footerBox">
      <div>
        <input type="button" value="上一步" class="button prev" @click="goPrev">
        <input type="button" value="确认发布" id="btn" class="button green" @click="publish">
      </div>
    </article>
  </section>
</template>

<script>
import classcom from "./../checkboxLabel/checkboxLabel.vue";
import notice from "./../../components/notice/notice.vue";
import EditInput from "./../../components/editInput/editInput";
import { clientId, brandId } from "./../../config";
import fetch from "./../../fetch";
import {
  nowDate,
  formatDate,
  aroundDate,
  timeStamp,
  formatDataToMinutes
} from "./../../filter";
import { mapGetters, mapActions } from "vuex";
import OriginSelect from "./../../components/originSelect/originSelect";

export default {
  data() {
    return {
      grads: [],
      selectedClass: [],
      workName: "",
      dateShow: "",
      sendDate: "",
      completeDate: [],
      endDate: "",
      workMessage: "",
      isNotice: false,
      noticParams: {},
      publishType: "",
      examinationID: "",
      examinationTitle: "",
      paperScore: "",
      clickIndex: 1,
      paperSubjectId: Number,
      allTimes: 0,
      articles: [],
      words_text: ["跟读", "朗读"],
      text_text: ["跟读", "朗读", "背诵"],
      allCheckClassArr: [],
      partCheckClassArr: [],
      checkClassArr: [],
      check: "",
      params_type: 0,
      defalutTitle: "选择",
      seltime: {},
      default_V: {},
      target: "",
      serviceId:''
    };
  },
  components: {
    classcom,
    notice,
    EditInput,
    OriginSelect
  },
  created() {
    this.$nextTick(() => {
      this.default_V.defHour = formatDate(timeStamp(), "hh");
      console.log(formatDate(timeStamp(), "hh"));
      this.default_V.defMinute = formatDate(timeStamp(), "mm");
      this.setCrumb("布置作业");
      this.initData();
      this.serviceId = this.$route.query.serviceId
    });
  },
  methods: {
    ...mapActions([
      "setCrumb",
      "setWorks",
      "cleanCatalog",
      "removeWorks",
      "removeSubject"
    ]),
    ...mapGetters(["getWorks"]),
    changeTitle(val) {
      this.workName = val.trim()?val: this.workName;
    },
    selLi(item) {
      item.setQuestionId = !item.setQuestionId;
    },
    initData() {
      if (!this.getWorks().contents) {
        this.$router.push({ path: "/" });
        return;
      }
      let params = this.$route.query;
      this.params_type = params.type;
      if (params.type == 2) {
        this.publishType = params.type;
        this.examinationID = params.paper.examinationID;
        this.paperSubjectId = params.paper.subjectID;
        this.paperScore = params.paper.refScore;
        this.examinationTitle = params.paper.examinationTitle;
        // this.workName = formatDate(timeStamp(), 'y年M月dd日')+this.examinationTitle;
        this.workName = this.examinationTitle;
      } else {
        let selectedWorkName = params.selectedWorkName.substr(
          0,
          params.selectedWorkName.length - 1
        );
        // this.workName = formatDate(timeStamp(), 'y-M-dd')+'作业';
        this.workName = selectedWorkName;
        this.articles = this.getWorks().contents;
        this.articles.map(item => {
          if (item.refLong) {
            this.allTimes += item.refLong;
          }
        });
      }

      const nextDate = aroundDate("", 1) / 1000;
      this.completeDate = [
        formatDate(nextDate, "yyyy-MM-dd"),
        formatDate(nextDate, "hh"),
        formatDate(nextDate, "mm")
      ];
      this.endDate = formatDate(nextDate, "yyyy-MM-dd");
      this.target = this.getWorks().target;

      this.initPage();
    },
    initPage() {
      document.getElementById("myID").flatpickr({
        dateFormat: "Y-m-d",
        minDate: formatDate(
          aroundDate(null, 1) / 1000,
          "yyyy-MM-dd"
        ).toString(),
        time_24hr: false,
        shorthandCurrentMonth: true,
        enableTime: false
      });
      let _this = this;
      document.getElementById("myIDSecond").flatpickr({
        dateFormat: "Y-m-d",
        minDate: "today",
        time_24hr: false,
        shorthandCurrentMonth: true,
        enableTime: false,
        onChange: function(selectedDates) {
          _this.endDate = formatDate(
            aroundDate(selectedDates, 1) / 1000,
            "yyyy-MM-dd"
          );

          _this.completeDate[0] = _this.endDate;
          _this.sendDate = formatDate(timeStamp(selectedDates), "yyyy-MM-dd");
        }
      });
    },
    modify(type) {
      this.check = !this.check;
      if (type == 2) {
        this.dateShow = true;
        this.sendDate = formatDate(timeStamp(), "yyyy-MM-dd");
        this.default_V.Hour = new Date().getHours() + 1;
      } else {
        this.dateShow = false;
        this.sendDate = '';
      }
    },
    selClass(obj) {
      if (obj.checked) {
        this.selectedClass.push(obj.id);
      } else {
        let index = this.selectedClass.indexOf(obj.id);
        this.selectedClass.splice(index, 1);
      }
    },
    // adClass() {
    //   this.isNotice = !this.isNotice;
    //   this.noticParams = {
    //     type: 1,
    //     noticeText: "调整班级后，已添加的作业内容将会被删除，确定调整班级？",
    //     noticeTitle: "系统提示"
    //   };
    // },
    // preview(item, index) {
    //   let query = {
    //     resourceName: item.resourceName,
    //     parentVersionId: item.parentVersionId,
    //     versionId: item.versionId,
    //     moduleId: item.moduleId,
    //     checkedResource: item.checkedResource,
    //     readTime: item.refLong,
    //     resourceType: item.resourceType,
    //     selectFlag: false
    //     // cId: item.cId
    //   };
    //   if (item.moduleId == 10 || item.moduleId == 127) {
    //     //同步跟读
    //     if (item.resourceType == "a7527f97-14e6-44ef-bf73-3039033f128e") {
    //       this.$router.push({ path: "readWords", query });
    //     } else if (
    //       item.resourceType == "992a5055-e9d0-453f-ab40-666b4d7030bb"
    //     ) {
    //       this.$router.push({ path: "selectText", query });
    //     }
    //   } else if (item.moduleId == 15) {
    //     //听说模考
    //     this.$router.push({ path: "selectListenSpeak", query });
    //   } else if (item.moduleId == 124) {
    //     //线上作答
    //     this.$router.push({ path: "selectOnlinePaper", query });
    //   }
    // },
    selecter(obj) {
      if (obj.key === "hours") {
        this.completeDate[1] = obj.value;
        // this.seltime.hours = obj.value
      } else if (obj.key === "minutes") {
        this.completeDate[2] = obj.value;
        // this.seltime.minutes = obj.value
      } else if (obj.key === "time_hours") {
        this.seltime.time_hours = obj.value;
        let selectDate = new Date(this.sendDate.replace(/-/g,'/')).getTime() / 1000 + this.seltime.time_hours * 60 * 60 + this.default_V.defMinute * 60;
        let nowTime = Math.ceil(+new Date() / 1000);
        if (selectDate < nowTime) {
          this.$toast("定时发布时间至少比现在晚1个小时。");
        }
      } else if (obj.key === "time_minutes") {
        this.seltime.time_minutes = obj.value;
      }
    },
    goPrev() {
      this.$router.go(-1);
    },
    publish() {
      document.getElementById("btn").disabled = true;
      let time_hours = this.seltime.time_hours
        ? this.seltime.time_hours
        : this.default_V.Hour;
      let time_minutes = this.seltime.time_minutes
        ? this.seltime.time_minutes
        : this.default_V.defMinute;

      let selhours = this.seltime.hours
        ? this.seltime.hours
        : this.default_V.defHour;
      let selminutes = this.seltime.minutes
        ? this.seltime.minutes
        : this.default_V.defMinute;

      let sendDate = this.sendDate + " " + time_hours + ":" + time_minutes;
      
      let endDate = this.endDate + " " + selhours + ":" + selminutes;
      let publishUserName = JSON.parse(localStorage.getItem("user")).realName;
      let obj = {
        // workName: this.workName || formatDate(timeStamp(), 'y年M月dd日')+this.selectedWorkName,
        workName: this.workName,
        workMessage: this.workMessage || "同学们请按时完成作业",
        completeDate: timeStamp(endDate),
        publishUserName: publishUserName,
        sendDate: this.sendDate ? timeStamp(sendDate) : 0
        // sendDate: this.sendDate ? timeStamp(sendDate) : Math.ceil(+new Date() / 1000)
        // classList: gradsList
      };

      if (obj.endDate < obj.sendDate) {
        this.$toast("作业发送时间不能大于作业截止时间！", "error");
        return false;
      }
      if (this.publishType == 2) {
        obj = Object.assign({}, obj, {
          workMessageType: 1,
          publishType: 1,
          // sourceType: clientId,
          workType: 0,
          userList: this.getWorks().userList,
          bookId: 0,
          bookName: "",
          subjectId: this.paperSubjectId
        });
        let contents = [
          {
            workTag: 2,
            moduleId: 124,
            versionId: this.examinationID,
            packageId: "0",
            cId: "0",
            parentVersionId: "0",
            resourceName: this.examinationTitle,
            resourceType: "1f693f76-02f5-4a40-861d-a8503df5183f",
            checkedResource: "",
            requirementContent: {
              readtimes: 1,
              speekingtype: 1
            },
            workScore: this.paperScore
          }
        ];
        this.setWorks({ contents: [] });
        this.setWorks({ contents: contents });
      }
      this.setWorks(obj);
      let workData = this.getWorks();
      console.log(workData);
      fetch.publish(workData).then(res => {
        if (!res.data) {
          var _this = this;
          setTimeout(function() {
            _this.$router.push({ path: "/login" });
          }, 2000);
          return false;
        }
        // if(workData.classList.length == 1) {
        //     window.localStorage.setItem("serviceId",this.serviceId)
        // }
        this.cleanCatalog();
        this.removeWorks();
        this.removeSubject();
        window.sessionStorage.setItem("pageIndex", 1);
        window.sessionStorage.removeItem('studentsTemp')
        
        this.$router.push({ path: "publishFinish" });
      });
    },
    isConfirm() {
      let query = {
        bookType: 1
      };
      this.$router.push({ path: "selectObject", query });
    }
  }
};
</script>



// WEBPACK FOOTER //
// publishBooks.vue?4503eecf